function init() {
	
	for (const accordion of document.querySelectorAll('[data-accordion]')) {

		const triggers = accordion.querySelectorAll('[data-accordion-item-trigger]')
		// const sections = accordion.querySelectorAll('[data-accordion-item-section]')
		
		for (const trigger of triggers) {

			trigger.addEventListener('click', () => {

				// Get id of section controlled by trigger
				const section = document.getElementById(trigger.getAttribute('aria-controls'))

				// Find out if section is already expanded
				const isExpanded = trigger.getAttribute('aria-expanded')
				
				// If not yet expanded
				if (isExpanded === 'false') {

					trigger.setAttribute('aria-expanded', 'true')
					section.removeAttribute('hidden')
				}
				else
				{
					trigger.setAttribute('aria-expanded', 'false')
					section.setAttribute('hidden', '')
				}
			})
		}
	}
}

export default init